"use client";
import React, { useEffect, useRef, useState, useMemo } from "react";
import dynamic from "next/dynamic";
import SubjectAccordianFilter from "./filter-accordians/subject-accordian-filter";
import {
  KeyNames,
  filterbodyJson,
} from "@packages/lib/utlils/filters/filterJson";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
import { useSearchParams, usePathname, useRouter } from "next/navigation";
import {
  LOCATION_MILES_ARRAY,
  GET_FILTER_PRIORITY,
  getUniversityFirstLetter,
} from "./filter-contant-values/filter-constants";
import {
  determineLocationType,
  extractUrlAndSessionValues,
  getParentSubject,
  getParentAndChildRegions,
  universitiesSortingList,
  modifySearchParams,
  constructSearchParams,
  checkIfParentSubjectChanged,
  handleCookiesAndSession,
} from "@packages/lib/utlils/filters/result-filters";
import { deleteDocumentCookie } from "@packages/lib/utlils/cookie-utils";
import API_URL from "@packages/lib/server-actions/api-urls";
import {
  cleanUniversityUrl,
  getSearchPayload,
} from "@packages/shared-components/services/utils";
import { getCookieValue } from "@packages/lib/utlils/commonFunction";
import { DataLayerGA4AttrType, GA4EventAttrType } from "@packages/lib/types/datalayerGA";
import { useFilterContext } from "@packages/lib/utlils/use-context/filter-context";
import {
  GA4DataLayerFn,
  getQualTextForQualIdClient,
  getCookie,
  GA4DataLayer,
} from "@packages/lib/utlils/helper-function";
import {
  ClickstreamInterface,
  logClickstreamEvent,
} from "@packages/lib/utlils/clickstream";
import { ClickstreamConstants, GAConstants } from "@packages/shared-components/services/constants";
//import { getPageNameGACS } from "@packages/lib/utlils/common-function-server";
import YearAndMonthAccordianFilter from "./filter-accordians/year-month-accordian";
import UniversityAccordianFilter from "./filter-accordians/uni-accordian-filter";
import LocationFilterAccordian from "./filter-accordians/location-accordian-filter";
import UniversityGroupFilterAccordian from "./filter-accordians/uni-group-accordian-filter";
import { searchFilterApiCall } from "./api-calls/filter-api-call";
import { cleanUrl } from "@packages/lib/utlils/url-builder";
const FilterSpinner = dynamic(
  () =>
    import("@packages/shared-components/skeleton/search-result/filter-spinner"),
  { ssr: false },
);
type KeyValueObject = Record<string, string>;

const SearchFilterComponent = ({ data, path, body }: any) => {
  const isWhatuni = process.env.PROJECT === "Whatuni";
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    slug,
    setSlug,
    routerEnd,
    setrouterEnd,
    setSelectedLocation,
    prepopulateFilter,
    setPrepopulateFilter,
    setUniversityState,
    setSubjectState,
    filterState,
    setFilterState,
    locationState,
    setLocationState,
  } = useFilterContext();
  const keyName = KeyNames();
  const [pageNameGaCs, setPageNameGaCs] = useState<string>("");
  const filterRef = useRef<HTMLDivElement | null>(null);
  const locationRef = useRef<HTMLDivElement | null>(null);
  const [jsondata, setJsondata] = useState(data);
  const [initiateTrigger, setInitiateTrigger] = useState(true);
  const [urlAndSession, setUrlAndSession] = useState(
    extractUrlAndSessionValues(searchParams, "", ""),
  );

  const universitiesList = useMemo(
    () => universitiesSortingList(jsondata),
    [jsondata],
  );

  const universityClicked = (
    displayHeading: string,
    id: string,
    isUniOpen?: boolean,
  ) => {
    setUniversityState((prev: any) => ({
      ...prev,
      isUniversityDropdownOpen: false,
      isUniversityOpen: isUniOpen,
      selectUniId: { id, displayHeading },
    }));
  };

  useEffect(() => {
    const handleFilterClickOutside = (event: MouseEvent) => {
      const body = document.body;
      const target = event.target as Element;
      const isClickOnOverlay =
        target.classList?.contains("animate-fadeIn") &&
        target.classList?.contains("block");

      if (
        filterRef.current &&
        !filterRef.current.contains(event.target as Node) &&
        body.classList.contains("overflow-y-hidden")
      ) {
        if (isClickOnOverlay) handleFilterClickGA("mouseEvent");
        setFilterState((prev: any) => ({
          ...prev,
          isFilterOpen: false,
          selectedFilter: null,
        }));
        body.classList.remove("overflow-y-hidden");
      }
    };

    const handleLocationClickOutside = (event: MouseEvent) => {
      if (
        locationRef.current &&
        !locationRef.current.contains(event.target as Node)
      ) {
        setLocationState((prev: any) => ({
          ...prev,
          isdropDownOpen: false,
        }));
      }
    };

    emitter.on("resetStateValues", resetStateValues);
    document.addEventListener("mousedown", handleFilterClickOutside);
    document.addEventListener("mousedown", handleLocationClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleFilterClickOutside);
      document.removeEventListener("mousedown", handleLocationClickOutside);
      emitter.off("resetStateValues", resetStateValues);
    };
  }, []);

  useEffect(() => {
    const refreshFilters = () => {
      setFilterState((prev: any) => ({
        ...prev,
        filterOrder: extractAndOrderFilters(
          new URLSearchParams(window.location.search),
          "",
          "",
          locationState,
          filterState,
        ),
      }));
      setInitiateTrigger(true);
      setrouterEnd(true);
    };
    setPageNameGaCs(localStorage.getItem("gaPageName") || "");
    const handleTogglePopup = (eventName: string | null | undefined) => {
      if (typeof document === "undefined") return;
      const element = document.getElementById(`#${eventName}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      setFilterState((prev: any) => ({
        ...prev,
        isFilterOpen: true,
        selectedFilter: eventName,
      }));
      document.body?.classList?.add("overflow-y-hidden");
    };
    emitter.on("refreshFilters", refreshFilters);
    emitter.on("isfilterOpen", handleTogglePopup);
    return () => {
      emitter.off("refreshFilters", refreshFilters);
      emitter.off("isfilterOpen", handleTogglePopup);
    };
  }, [searchParams]);

  useEffect(() => {
    const handleRefreshFilters = () => {
      setPrepopulateFilter({
        studyMethod: filterState?.filterOrder?.[keyName?.studyMethod] || "",
        studyMode: filterState?.filterOrder?.[keyName?.studyMode] || "",
        year: filterState?.filterOrder?.[keyName?.year] || "",
        month: filterState?.filterOrder?.[keyName?.month] || "All month",
        location: filterState?.filterOrder?.[keyName?.location] || "",
        russellGroup: filterState?.filterOrder?.[keyName?.russellGroup] || "",
        locationType: filterState?.filterOrder?.[keyName?.locationType] || "",
        university: filterState?.filterOrder?.[keyName?.university] || "",
        qualication: filterState?.filterOrder?.[keyName?.studyLevel] || "",
        subject:
          filterState?.filterOrder?.[keyName?.subject] ||
          filterState?.filterOrder?.[keyName?.keyword] ||
          "",
        studyLevel:
          window?.location?.pathname?.split("/")[1] ||
          pathname?.split("/")[1] ||
          "",
      });
      setSlug(pathname || path);
      const urlSearchParam = new URLSearchParams(window.location.search);
      const parentSubjectName = getParentSubject(urlSearchParam, jsondata);
      if (parentSubjectName) {
        subjectClicked(parentSubjectName, true);
      } else {
        const subject =
          urlSearchParam?.get(keyName?.subject)?.split(" ")[0] ||
          urlSearchParam?.get(keyName?.keyword)?.split(" ")[0];
        const isUrlSubjectParent = jsondata?.subjectFilterList?.find(
          (subjects: any) => subjects?.subjectTextKey == subject,
        );
        if (isUrlSubjectParent) {
          subjectClicked(isUrlSubjectParent?.categoryDesc, true);
        }
      }
      const isUniversityAdded = searchParams?.get(keyName?.university) || null;
      if (isUniversityAdded) {
        const sortedUni = universitiesList?.find((uni: any) =>
          uni?.sortingValue?.includes(
            getUniversityFirstLetter(isUniversityAdded),
          ),
        );
        if (sortedUni) {
          setUniversityState((prev: any) => ({
            ...prev,
            isUniversityOpen: true,
          }));
          universityClicked(sortedUni?.displayHeading, sortedUni?.id, true);
        }
      }
      const selectedLocations = determineLocationType(
        jsondata?.regionList,
        jsondata?.cityList,
        window.location.search,
      );
      if (filterState?.filterOrder?.[keyName?.location]) {
        const { parent, child } = getParentAndChildRegions(
          filterState,
          jsondata?.regionList,
        );
        setLocationState((prev: any) => ({
          ...prev,
          appliedParentRegion: parent,
          appliedChildRegion: child,
        }));
      } else {
        setLocationState((prev: any) => ({
          ...prev,
          appliedParentRegion: [],
          appliedChildRegion: [],
        }));
      }
      setSelectedLocation(selectedLocations);
      setUrlAndSession(extractUrlAndSessionValues(searchParams, "", ""));
      setInitiateTrigger(false);
    };
    if (initiateTrigger) {
      handleRefreshFilters();
    }
    emitter.on("refreshFilters", handleRefreshFilters);
    return () => {
      emitter.off("refreshFilters", handleRefreshFilters);
    };
  }, [searchParams, initiateTrigger]);

  useEffect(() => {
    const dynamicFilter = async () => {
      if (routerEnd) {
        setrouterEnd(false);
        const body = filterbodyJson(
          filterState?.filterOrder,
          prepopulateFilter?.studyLevel,
        );
        const data = await 
          searchFilterApiCall(API_URL?.srPrFilterPath, body);
        setJsondata(data);
        setSubjectState((prev: any) => ({
          ...prev,
          subjectkeyword: "",
        }));
        setUniversityState((prev: any) => ({
          ...prev,
          universityKeyword: "",
          isUniversityDropdownOpen: false,
        }));
        setFilterState((prev: any) => ({ ...prev, isFilterLoading: false }));
        setInitiateTrigger(true);
      }
    };
    dynamicFilter();
  }, [routerEnd, searchParams]);

  useEffect(() => {
    if (filterState?.isFilterOpen && filterRef.current) {
      filterRef.current.scrollTop = filterRef.current.scrollHeight;
    }
  }, [filterState?.isFilterOpen]);

  const closeFilter = () => {
    handleFilterClickGA("closeFilter");
    setFilterState((prev: any) => ({
      ...prev,
      isFilterOpen: false,
      selectedFilter: null,
    }));
    const body = document.body;
    body.classList.remove("overflow-y-hidden");
  };

  const ShowResults = () => {
    handleFilterClickGA("showResults");
    handleClickStream();
    const body = document.body;
    body?.classList?.remove("overflow-y-hidden");
    setFilterState((prev: any) => ({ ...prev, isFilterOpen: false }));
  };

  const resetStateValues = () => {
    const initialSubjectState = {
      subjectkeyword: "",
      sortedSubjects: [],
      isSujectDropdownOpen: false,
      isSubjectOpen: false,
      selectedSubject: {
        parentSubject: {},
        subjectList: [],
      },
    };

    const initialLocationState = {
      isdropDownOpen: false,
      mileDisplayName: "Any",
      selectedMile: "any",
      locationMilesArray: LOCATION_MILES_ARRAY,
      locationMilesError: false,
      postCodeValue: "",
      appliedParentRegion: [],
      appliedChildRegion: [],
    };
    setSubjectState(initialSubjectState);
    setLocationState(initialLocationState);
  };

  const extractAndOrderFilters = (
    searchParams: URLSearchParams,
    key: string,
    value: string,
    locationState: any,
    filterState: any,
    isUniversitySelected: boolean = false,
    isDifferentParentSubject: boolean = false,
    changeSubject?: string,
  ) => {
    if (key === keyName?.month && value === "All month") {
      value = filterState?.filterOrder?.month;
    }
    const filters = extractUrlAndSessionValues(
      searchParams,
      key,
      value,
      isDifferentParentSubject,
    );
    if (changeSubject && isWhatuni) {
      filters[keyName?.subject] = changeSubject;
    }
    if (key == keyName?.postcode) {
      filters[keyName?.distance] = locationState?.selectedMile;
    } else if (key == keyName?.distance) {
      filters[keyName?.postcode] = locationState?.postCodeValue;
    }
    return GET_FILTER_PRIORITY(isUniversitySelected)?.reduce(
      (acc, priorityKey) => {
        if (filters[priorityKey]) acc[priorityKey] = filters[priorityKey];
        return acc;
      },
      {} as KeyValueObject,
    );
  };

  const clearFilter = () => {
    const university = searchParams?.get(keyName?.university) || "";
    const urlparam = cleanUrl(
      `${university ? `?${keyName?.university}=${university}` : `/${isWhatuni ? `${window.location.pathname?.split("/")[1]}` : window.location.pathname}`}`,
    );
    window.history.pushState(null, "", urlparam);
    const param = new URLSearchParams(window.location.search);
    setFilterState((prev: any) => ({
      ...prev,
      filterOrder: extractUrlAndSessionValues(param, "", ""),
      isFilterLoading: true,
    }));
    resetStateValues();
    sessionStorage.setItem("filter_param", "{}");
    deleteDocumentCookie([
      { name: "filter_param" },
      { name: "min" },
      { name: "ucaspoint" },
      { name: "UCAS" },
    ]);
    emitter.emit("refreshFilters");
    setrouterEnd(true);
    router.push(urlparam);
  };

  const searchPayLoad = getSearchPayload(
    urlAndSession,
    getCookieValue("filter_param"),
    decodeURIComponent(getCookieValue("pathnamecookies"))?.split("/")[1] ?? "",
    getCookieValue("dynamic_random_number") || "",
    "",
  );

  const subjectInURL =
    searchPayLoad?.searchSubject?.length > 0
      ? searchPayLoad?.searchSubject?.[0]
      : (searchPayLoad?.searchKeyword ?? "");

  const locationType = Array.isArray(searchPayLoad?.locationType)
    ? searchPayLoad?.locationType?.join(",")
    : searchPayLoad?.locationType;
  const parentSubCurr =
    jsondata?.subjectFilterList?.find(
      (item: any) => item?.subjectTextKey === subjectInURL,
    )?.parentSubject || null;

  const childSubCurr =
    jsondata?.subjectFilterList?.find(
      (item: any) => item?.subjectTextKey === subjectInURL,
    )?.categoryDesc || null;

  const handleFilterClickGA = async (clickType: string) => {
    const urlparams = new URLSearchParams(window.location.search);

    const gaOldData: DataLayerGA4AttrType = {
      event: "ga_events",
      eventName: "filter_applied",
      page_name: pageNameGaCs,
      college_name: searchPayLoad?.collegeName,
      cpe_parent_subject: parentSubCurr || childSubCurr,
      cpe_child_subject: parentSubCurr ? childSubCurr : "",
      ucas_points: searchPayLoad?.ucasTariffRange,
      study_mode: filterState?.filterOrder?.[`study-mode`],
      target_year: searchPayLoad?.intakeYear,
      study_level: isWhatuni
        ? getQualTextForQualIdClient(searchPayLoad?.parentQualification)
        : searchPayLoad?.childQualification,
      data_label: searchPayLoad?.studyMethod,
      data_label2: filterState?.filterOrder?.[`location-type`],
      data_label3: filterState?.filterOrder?.[`russell-group`]
        ? keyName?.russellGroup
        : "",
      data_label4: searchPayLoad?.intakeMonth,
      data_label5: searchPayLoad?.pageNo,
      destination_country: filterState?.filterOrder?.[`location`],
    };
    GA4DataLayerFn(gaOldData);
      const gaData: GA4EventAttrType = {
      event: GAConstants.track_event,
      event_name: "filters_submit",
      institution_name: searchPayLoad?.collegeName,
      subject_area: parentSubCurr || childSubCurr,
      subject_discipline: parentSubCurr ? childSubCurr : "",
      study_mode: filterState?.filterOrder?.[`study-mode`],
      study_level: isWhatuni
        ? getQualTextForQualIdClient(searchPayLoad?.parentQualification)
        : searchPayLoad?.childQualification,
      destination_region_city: filterState?.filterOrder?.[`location`],
    };
    GA4DataLayer(gaData);
  };
  var csData: ClickstreamInterface = {} as ClickstreamInterface;

  const handleClickStream = () => {
    const gradeAppliedList = JSON.parse(
      decodeURIComponent(getCookie("UCAS") || "{}"),
    );
    const gradeApplied = gradeAppliedList?.userStudyLevelEntry
      ?.map((gradeItems: { SelectedLevel: any }) => gradeItems?.SelectedLevel)
      ?.join("|");
    const urlparams = new URLSearchParams(window.location.search);
    csData.eventType = ClickstreamConstants.filterClickedEvent;
    csData.CTATitle = ClickstreamConstants.filterCTATitle;
    csData.studyLevel = isWhatuni
      ? getQualTextForQualIdClient(searchPayLoad?.parentQualification)
      : "";
    csData.studyMode = searchPayLoad?.studyMode;
    csData.pageName =
      urlparams.toString().indexOf("&university") === -1 &&
      urlparams.toString().indexOf("?university") === -1
        ? "browsemoneypageresults"
        : "coursesearchresult";
    csData.subject = childSubCurr || parentSubCurr;
    csData.interestedIntakeYear = searchPayLoad?.intakeYear;
    csData.subjectGrade = gradeApplied;
    csData.functionalityName = "Search result";
    csData.childStudyLevel = !isWhatuni
      ? searchPayLoad?.childQualification
      : "";
    csData.searchKeyword = searchPayLoad?.searchKeyword;
    csData.actionType = ClickstreamConstants.clickAction;
    csData.sortOption = searchPayLoad?.sortBy || "";
    csData.locationType = locationType || "";
    csData.studyModeId = searchPayLoad?.studyMode;
    csData.networkId =
      getQualTextForQualIdClient(
        searchPayLoad?.parentQualification,
      )?.toLowerCase() === "postgraduate" || !isWhatuni
        ? "3"
        : "2";

    csData.SRInstitutionIDOrder = "";

    logClickstreamEvent(csData);
  };
  const appendSearchParams = async (
    key: string,
    originalValue: string,
    isUniversitySelected?: boolean,
    isQualificationChanged?: boolean,
    changeSubject?: string,
  ) => {
    let value = originalValue;
    if (!routerEnd) {
      setFilterState((prev: any) => ({ ...prev, isFilterLoading: true }));
      const urlSearchParam = new URLSearchParams(window?.location?.search);

      if (key === keyName?.studyLevel && isWhatuni) {
        setPrepopulateFilter((prev: any) => ({
          ...prev,
          studyLevel: `${value}-courses`,
        }));
      }

      if (originalValue === "All month") {
        value = prepopulateFilter?.month;
      }
      const isDifferentParentSubject = checkIfParentSubjectChanged(
        key,
        value,
        jsondata,
        urlSearchParam,
      );
      const orderedFilters = extractAndOrderFilters(
        urlSearchParam,
        key,
        value?.toLowerCase(),
        locationState,
        filterState,
        isUniversitySelected,
        isDifferentParentSubject,
        changeSubject,
      );
      if (key == keyName?.subject) {
        delete orderedFilters?.[keyName?.keyword];
      }
      setFilterState((prev: any) => ({
        ...prev,
        filterOrder: orderedFilters,
      }));

      const { urlParams, cookieParams } = constructSearchParams(orderedFilters);
      handleCookiesAndSession(cookieParams);

      let domainPath = null;
      if (isWhatuni) {
        if (
          isQualificationChanged &&
          slug?.split("/")[1] !== `${value}-courses`
        ) {
          domainPath = `/${value}-courses/${slug?.split("/")[2]}`;
        } else if (key === keyName?.university) {
          const uniSelected = urlSearchParam
            ?.get(keyName?.university)
            ?.includes(value);
          domainPath = `/${slug?.split("/")?.[1]}/${uniSelected ? "search" : "csearch"}`;
        } else {
          domainPath = `/${slug?.split("/")?.[1]}/${orderedFilters?.university ? "csearch" : orderedFilters?.subject ? "search" : ""}`;
        }
      }

      if (
        urlParams.toString() ===
          new URLSearchParams(window?.location?.search)?.toString() &&
        !isQualificationChanged
      ) {
        router.refresh();
      } else {
        const normalizedUrl = cleanUrl(
          cleanUniversityUrl(`${domainPath ?? ""}?${urlParams.toString()}`),
        );

        if (key === keyName?.keyword) {
          window.location.href = normalizedUrl;
          return;
        }

        window?.history?.pushState(null, "", normalizedUrl);

        router.push(normalizedUrl);
      }
    }
    setrouterEnd(true);
  };

  const formUrl = (
    key: string,
    value: string,
    isQualification?: boolean,
    changeSubject?: string,
  ) => {
    const isDifferentParentSubject = checkIfParentSubjectChanged(
      key,
      value,
      jsondata,
      searchParams,
    );
    const orderedFilters = extractAndOrderFilters(
      searchParams,
      key,
      value?.toLowerCase(),
      locationState,
      filterState,
      isQualification,
      isDifferentParentSubject,
      changeSubject,
    );
    const urlParams = new URLSearchParams();
    let totalValues = 0;
    const exlcudedKey = [
      "study-level",
      keyName?.month,
      keyName?.year,
      keyName?.russellGroup,
      keyName?.studyMethod,
      keyName?.locationType,
    ];
    Object.entries(orderedFilters)?.forEach(([k, v]) => {
      if (
        totalValues + v?.split("+")?.length <= 4 &&
        !exlcudedKey.includes(k)
      ) {
        urlParams?.set(k, v);
        totalValues += v?.split("+")?.length;
      }
    });
    let paramString = "";

    if (key === keyName?.subject) {
      const singleSubject = searchParams?.get(keyName?.subject)?.split(" ");

      if (singleSubject?.length === 1 && singleSubject[0] === value) {
        paramString = ``;
      } else {
        paramString = modifySearchParams(key, value, urlParams)?.toString();
      }
    } else {
      const urlObject = Object.fromEntries(urlParams?.entries());

      [keyName?.subject, keyName?.location]
        ?.filter(Boolean)
        ?.forEach((paramKey) => {
          if (urlObject[paramKey]) {
            urlObject[paramKey] = urlObject[paramKey]?.split("+")[0] || "";
          }
        });

      paramString = new URLSearchParams(urlObject)?.toString();
    }
    console.log("urlp3", paramString?.includes("method"), paramString);
    if (
      Object.keys(Object.fromEntries(searchParams.entries()))?.length >= 4 &&
      key !== keyName?.subject
    ) {
      paramString = `${searchParams?.get(keyName?.subject) ? `${keyName?.subject}=${searchParams?.get(keyName?.subject)}&` : ""}${key}=${value}`;
    }

    return cleanUrl(cleanUniversityUrl(paramString));
  };

  const subjectClicked = (item: string, closeFilter?: boolean) => {
    const L2subject = jsondata?.subjectFilterList?.filter(
      (items: any) => items?.parentSubject === item,
    );
    const parentSubjectObject = jsondata?.subjectFilterList?.find(
      (subjects: any) => subjects.categoryDesc == item,
    );
    setSubjectState((prev: any) => ({
      ...prev,
      isSujectDropdownOpen: false,
      isSubjectOpen: closeFilter || !prev?.isSubjectOpen,
      selectedSubject: {
        parentSubject: parentSubjectObject,
        subjectList: L2subject,
      },
    }));
  };

  return (
    <>
      <div>
        <div
          className={`fixed top-0 left-0 w-full h-full bg-grey-600 backdrop-blur-custom-1 opacity-[80%] z-10 
             ${
               filterState?.isFilterOpen
                 ? "animate-fadeIn block"
                 : "animate-fadeOut hidden"
             }
          `}
        ></div>
        <div
          className={`bg-white fixed top-0 left-0 w-full h-full z-10 transition-all duration-300 ease-in-out md:w-[768px] ${
            filterState?.isFilterOpen ? "translate-x-0" : "-translate-x-full"
          }`}
          ref={filterRef}
        >
          {filterState?.isFilterLoading && <FilterSpinner />}
          <div className="p-[16px] md:p-[32px] !pb-0">
            <div className="flex justify-between">
              <h6 className="h2">Filter</h6>
              <svg
                onClick={closeFilter}
                className="mt-[-6px] ml-auto mr-[-6px] md:mt-[-22px] md:mr-[-22px] cursor-pointer"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18"
                  stroke="#333333"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 6L18 18"
                  stroke="#333333"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <p className="m-[8px_0_24px]">
              Use these filters to narrow down your search options based on your
              preferred criteria
            </p>
          </div>

          <div className="h-[calc(100%-215px)] overflow-y-auto custom-scrollbar-2 md:h-[calc(100%-213px)]">
            <SubjectAccordianFilter
              keyName={keyName}
              jsondata={jsondata}
              formUrl={formUrl}
              subjectClicked={subjectClicked}
              appendSearchParams={appendSearchParams}
            />
            <YearAndMonthAccordianFilter
              keyName={keyName}
              jsondata={jsondata}
              formUrl={formUrl}
              appendSearchParams={appendSearchParams}
            />
            <UniversityAccordianFilter
              keyName={keyName}
              jsondata={jsondata}
              formUrl={formUrl}
              appendSearchParams={appendSearchParams}
              universityClicked={universityClicked}
              universitiesList={universitiesList}
            />
            <LocationFilterAccordian
              keyName={keyName}
              jsondata={jsondata}
              formUrl={formUrl}
              locationRef={locationRef}
              appendSearchParams={appendSearchParams}
              urlAndSession={urlAndSession}
            />
            <UniversityGroupFilterAccordian
              keyName={keyName}
              jsondata={jsondata}
              formUrl={formUrl}
              appendSearchParams={appendSearchParams}
            />
          </div>

          <div className="flex items-center justify-between p-[16px] fixed w-full bottom-0 shadow-custom-10 bg-white md:p-[16px_32px] md:w-[768px]">
            <div className="min-w-[128px] text-center md:text-left">
              <div
                onClick={clearFilter}
                aria-label="reset filters"
                className="text-primary-400 font-semibold cursor-pointer hover:underline"
              >
                Clear
              </div>
            </div>
            {jsondata?.courseCount > 0 && (
              <button
                className="bg-primary-400 text-white rounded-[24px] py-[10px] px-[16px] font-semibold min-w-[200px] hover:bg-primary-500 md:w-[344px]"
                onClick={ShowResults}
              >
                Show{" "}
                {jsondata?.courseCount > 1
                  ? "all " + jsondata?.courseCount + " results"
                  : jsondata?.courseCount + " result"}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchFilterComponent;
